import * as React from 'react';

type Props = {
  flush?: boolean;                 // if true, no border radius / outer border
  children: React.ReactNode;       // V3SpecRow instances
};

/**
 * V3SpecsTable — wrapper around a list of V3SpecRow rows.
 *
 * Used in: workspace left panel (Module specs, Location, Building),
 * and New Project modal step 3 (module dimensions display).
 *
 * `flush` is used inside V3CollapsibleSection where the section
 * border already provides the outer shape — removes the table's
 * own border and radius so it blends in seamlessly.
 */
const V3SpecsTable: React.SFC<Props> = ({ flush = false, children }) => (
  <div className={`v3-specs-table ${flush ? 'flush' : ''}`}>
    {children}
  </div>
);

export default V3SpecsTable;
